// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
Vue.config.devtools = true
Vue.use(require('vue-resource'))
// import Hello from './components/Hello'
// import ClosingDate from './components/ClosingDate'
import ComponentOne from './components/ComponentOne'
import ComponentTwo from './components/ComponentTwo'
import ClosingDate from './components/ClosingDate'
import DemoHandsOn from './components/DemoHandsOn'
import TilpaAthleteStats from './components/TilpaAthleteStats'
import Rankings from './components/Rankings'
import RandomUser from './components/RandomUser.vue'
import Literal from './components/Literal.vue'
import DateField from './components/DateField.vue'
import ClubPicker from './components/ClubPicker.vue'

import Sheet from './components/Sheet.vue'
import SheetLine from './components/SheetLine.vue'
import SheetFunnel from './components/SheetFunnel.vue'

import Sorter from './components/Sorter.vue'
import Funnel from './components/Funnel.vue'
import Translation from './components/Translation.vue'

import {Tabs, Tab} from 'uiv'

/* eslint-disable no-new */
// new Vue({
//   el: '#component1',
//   components: { ComponentOne },
//   template: '<ComponentOne/>'
// })

// new Vue({
//   el: '#component2',
//   components: { ComponentTwo },
//   template: '<ComponentTwo/>'
// })

// Container, no template
var mainApp
try {
  // eslint-disable-next-line no-unused-vars
  mainApp = new Vue({
    el: '#vue_container_app',
    // eslint-disable-next-line no-undef
    mixins: [mainMixin],
    components: {
      ComponentOne,
      ComponentTwo,
      ClosingDate,
      DemoHandsOn,
      TilpaAthleteStats,
      RandomUser,
      Rankings,
      Literal,
      DateField,
      Tabs,
      ClubPicker,
      Tab,

      Sheet,
      SheetLine,
      SheetFunnel,

      Sorter,
      Funnel,
      Translation
    }
  })
} catch (e) {
  // eslint-disable-next-line no-unused-vars
  mainApp = new Vue({
    el: '#vue_container_app',
    components: {
      ComponentOne,
      ComponentTwo,
      ClosingDate,
      DemoHandsOn,
      TilpaAthleteStats,
      RandomUser,
      Rankings,
      Literal,
      DateField,
      Tabs,
      ClubPicker,
      Tab,

      Sheet,
      SheetLine,
      SheetFunnel,

      Sorter,
      Funnel,
      Translation
    }
  })
}
window.mainApp = mainApp



// WEBPACK FOOTER //
// ./src/main.js